import { useQuery } from '@tanstack/react-query';

import {
  FetchTravelDetailParams,
  FetchTravelListParams,
  TravelList,
  TravelDetail,
  TravelImageList,
  FetchTravelImageParams,
  TravelDetailIntro,
  FetchTravelDetailIntroParams,
  TravelDetailInfo,
} from '@/entites/travel/model/travel-type';
import { travelClient } from '@/shared/api/client/base-travel';

const fetchTravelList = async (params: FetchTravelListParams) => {
  const { data } = await travelClient.get(`/areaBasedList1`, { params });
  return data;
};

export const useTravels = (params: FetchTravelListParams) => {
  return useQuery<TravelList>({
    queryKey: ['Travels', JSON.stringify(params)],
    queryFn: () => fetchTravelList(params),
  });
};

const fetchTravelDetail = async (params: FetchTravelDetailParams) => {
  const { data } = await travelClient.get('/detailCommon1', { params });
  return data;
};

export const useTravelDetail = (params: FetchTravelDetailParams) => {
  return useQuery<TravelDetail>({
    queryKey: ['TravelDetail', JSON.stringify(params)],
    queryFn: () => fetchTravelDetail(params),
  });
};

const fetchTravelImages = async (params: FetchTravelImageParams) => {
  const { data } = await travelClient.get('/detailImage1', { params });
  return data;
};

export const useTravelImages = (params: FetchTravelImageParams) => {
  return useQuery<TravelImageList>({
    queryKey: ['TravelImages', JSON.stringify(params)],
    queryFn: () => fetchTravelImages(params),
  });
};

const fetchTravelDetailIntro = async (params: FetchTravelDetailIntroParams) => {
  const { data } = await travelClient.get(`/detailIntro1`, { params });
  return data;
};

export const useTravelDetailIntro = (params: FetchTravelDetailIntroParams) => {
  return useQuery<TravelDetailIntro>({
    queryKey: ['TravelDetailIntro', JSON.stringify(params)],
    queryFn: () => fetchTravelDetailIntro(params),
  });
};
const fetchTravelDetailInfo = async (params: FetchTravelDetailIntroParams) => {
  const { data } = await travelClient.get(`/detailInfo1`, { params });
  return data;
};

export const useTravelDetailInfo = (params: FetchTravelDetailIntroParams) => {
  return useQuery<TravelDetailInfo>({
    queryKey: ['TravelDetailInfo', JSON.stringify(params)],
    queryFn: () => fetchTravelDetailInfo(params),
  });
};
